/**
 * Capacity Dashboard Loading Skeleton
 *
 * Shows placeholder layout while capacity data is being fetched.
 */

import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

const CapacitySkeleton = () => (
    <div>
        {/* Summary Cards Skeleton - 6 cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-2">
            {[1, 2, 3, 4, 5, 6].map((i) => (
                <Card key={i} className="lg:col-span-2 col-span-12">
                    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                        <Skeleton className="h-4 w-20" />
                        <Skeleton className="h-5 w-5 rounded" />
                    </CardHeader>
                    <CardContent>
                        <Skeleton className="h-8 w-16 mb-2" />
                        <Skeleton className="h-3 w-24" />
                    </CardContent>
                </Card>
            ))}
        </div>

        {/* Charts Skeleton - 2 rows */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-2 mt-2">
            <Card className="lg:col-span-6 col-span-12">
                <CardHeader>
                    <Skeleton className="h-6 w-40" />
                </CardHeader>
                <CardContent>
                    <Skeleton className="h-[250px] w-full" />
                </CardContent>
            </Card>
            <Card className="lg:col-span-6 col-span-12">
                <CardHeader>
                    <Skeleton className="h-6 w-40" />
                </CardHeader>
                <CardContent>
                    <Skeleton className="h-[250px] w-full" />
                </CardContent>
            </Card>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-2 mt-2">
            <Card className="lg:col-span-4 col-span-12">
                <CardHeader>
                    <Skeleton className="h-6 w-36" />
                </CardHeader>
                <CardContent>
                    <Skeleton className="h-[200px] w-full" />
                </CardContent>
            </Card>
            <Card className="lg:col-span-8 col-span-12">
                <CardHeader>
                    <Skeleton className="h-6 w-44" />
                </CardHeader>
                <CardContent>
                    <Skeleton className="h-[200px] w-full" />
                </CardContent>
            </Card>
        </div>

        {/* Zone List Skeleton */}
        <Card className="mt-2">
            <CardHeader>
                <Skeleton className="h-6 w-32" />
            </CardHeader>
            <CardContent>
                <div className="space-y-2">
                    {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="flex items-center gap-4 py-2">
                            <Skeleton className="h-4 w-32" />
                            <Skeleton className="h-4 w-24" />
                            <Skeleton className="h-4 w-16" />
                            <Skeleton className="h-4 w-16" />
                            <Skeleton className="h-4 w-20" />
                            <Skeleton className="h-4 w-20" />
                            <Skeleton className="h-6 w-16 rounded-full" />
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    </div>
)

export default CapacitySkeleton
